import {mutationTypes} from '@/core/constants'

export default {

    [mutationTypes.SERVICO_ORCAMENTO.SET_FILTROS_BUSCA_TODOS_SERVICOS_ORCAMENTO](state, filtros) {
        state.resultadoBuscaTodosServicosOrcamento.filtros = filtros
    },

    [mutationTypes.SERVICO_ORCAMENTO.SET_PAGINACAO_BUSCA_TODOS_SERVICOS_ORCAMENTO](state, paginacao) {
        state.resultadoBuscaTodosServicosOrcamento.paginacao = paginacao
    },

    [mutationTypes.SERVICO_ORCAMENTO.RESETA_PAGE_SERVICO_ORCAMENTO](state) {
        state.resultadoBuscaTodosServicosOrcamento.paginacao.page = 1
    },
}